module.exports = __webpack_public_path__ + "img/ROIDaBc.363b9f05.webp";